export default "__VITE_ASSET__Dfs_BgZU__"